import React from "react";
import { InputSwitch } from "../../../../controls";

const InputSellable = ({ handleInpChg, item }) => {
  return (
    <>
      <InputSwitch
        size="small"
        className="gray-color"
        name="isSellable"
        onChange={(e) =>
          handleInpChg({
            name: "isSellable",
            id: item.id,
            value: e.target.checked,
          })
        }
        checked={item.isSellable}
      />
    </>
  );
};

export default InputSellable;
